module.exports = __webpack_public_path__ + "static/img/jgpj.9ed9721d.png";